import { _UserData } from 'base/src/infra/storage/localStorage';
import { CampanhaOAuthService } from './campanhaOAuthService';
import { CampanhaOAuthResponse } from '../../types/auth/campanhaOAuthResponse';

const CAMPANHA_TOKEN_KEY = 'CampanhaToken';
const CAMPANHA_TOKEN_EXPIRY_KEY = 'CampanhaTokenExpiry';
const EXPIRY_BUFFER_MS = 60 * 1000;

class CampanhaTokenManager {
    private static instance: CampanhaTokenManager = new CampanhaTokenManager();
    private refreshPromise: Promise<string | null> | null = null;
    private oauthService: CampanhaOAuthService = new CampanhaOAuthService();

    private constructor() { }

    public static get Instance(): CampanhaTokenManager {
        return this.instance;
    }

    async GetCampanhaToken(): Promise<string | null> {
        const token = _UserData.GetOtherData<string>(CAMPANHA_TOKEN_KEY);
        const expiryStr = _UserData.GetOtherData<string>(CAMPANHA_TOKEN_EXPIRY_KEY);

        if (token && token !== '' && expiryStr) {
            const expiry = Number(expiryStr);
            if (Date.now() < expiry - EXPIRY_BUFFER_MS) {
                return `Bearer ${token}`;
            }
        }

        return this.RefreshToken();
    }

    async RefreshToken(): Promise<string | null> {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        this.refreshPromise = this.doRefresh();

        try {
            return await this.refreshPromise;
        } finally {
            this.refreshPromise = null;
        }
    }

    private async doRefresh(): Promise<string | null> {
        const response = await this.oauthService.GetToken();

        if (response instanceof Error) {
            // eslint-disable-next-line no-console
            console.error('Falha ao obter token OAuth2 da Campanha:', response.message);
            return null;
        }

        const oauthResponse = response as CampanhaOAuthResponse;

        // Handle both OAuth2 standard (number of seconds) and custom format (ISO date string)
        let expiryTime: number;
        if (typeof oauthResponse.expires_in === 'number') {
            // Standard OAuth2: expires_in is seconds until expiration
            expiryTime = Date.now() + (oauthResponse.expires_in * 1000);
        } else {
            // Custom format: expires_in is an ISO date string
            expiryTime = new Date(oauthResponse.expires_in).getTime();
        }

        _UserData.SetOtherData(CAMPANHA_TOKEN_KEY, oauthResponse.access_token);
        _UserData.SetOtherData(CAMPANHA_TOKEN_EXPIRY_KEY, expiryTime.toString());

        return `Bearer ${oauthResponse.access_token}`;
    }
}

export const campanhaTokenManager = CampanhaTokenManager.Instance;
